export const initialAbility = [
    {
        action: 'READ',
        subject: 'infomation'
    },
    {
        action: 'READ',
        subject: 'agreement'
    }
]

export const _ = undefined
